export const ACTION_TYPES = {
  UPDATE_VIEW_OPTIONS: "UPDATE_VIEW_OPTIONS",
  UPDATE_PROPERTIES: "UPDATE_PROPERTIES",
  UPDATE_LOADED_TEAMS: "UPDATE_LOADED_TEAMS",
  UPDATE_PERSON_PARTIAL: "UPDATE_PERSON_PARTIAL",
  UPDATE_TEAM_TAGS: "UPDATE_TEAM_TAGS",
  MERGE_PARTIAL_DATA: "MERGE_PARTIAL_DATA",
  TOGGLE_CHANGELOG_VIEW: "TOGGLE_CHANGELOG_VIEW",
};
